import { TellescopeModelFromName, useTellescopeMutation } from "@tellescope/tanstack-query";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { BadgeConfig, BadgeDropdownCell } from "@tellescope/ui";
import { getStageConfig as getBaseStageConfig, type TicketStage } from "../utils/stageConfig";

const AVAILABLE_STAGES = ["Not Started", "In Progress", "Blocked", "Archived"] as const;

const getStageConfig = (stage: string): BadgeConfig => {
  const baseConfig = getBaseStageConfig(stage as TicketStage);
  return {
    label: baseConfig.label,
    bgColor: baseConfig.bgColor,
    textColor: baseConfig.textColor,
  };
};

export interface StageCellProps {
  stage: TellescopeModelFromName<"tickets">["stage"];
  ticketId: string;
  disableChangeStage?: boolean;
}

export const StageCell = ({ stage = "Not Started", ticketId, disableChangeStage }: StageCellProps) => {
  const { t } = useTranslation("tickets");

  const updateTicketMutation = useTellescopeMutation({
    model: "tickets",
    method: "updateOne",
  });

  const handleStageChange = useCallback(
    (newStage: string) => {
      updateTicketMutation.mutateAsync({
        id: ticketId,
        stage: newStage,
      });
    },
    [ticketId, updateTicketMutation]
  );

  return (
    <BadgeDropdownCell
      value={stage}
      options={AVAILABLE_STAGES}
      getConfig={getStageConfig}
      onChange={handleStageChange}
      disabled={disableChangeStage || !ticketId}
      unknownLabel={t("Unknown Stage")}
    />
  );
};
